export enum AuthQueryParamsType {
  AUTH_TYPE = 'authType',
  FORGOT_PASSWORD_TOKEN = 'forgotPasswordToken',
  REDIRECT_TO = 'redirectTo',
}

export enum AuthType {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  RECOVER_PASS = 'RECOVER_PASS',
  LESS = 'LESS',
  RESET_PASS = 'RESET_PASS',
}

export enum AuthErrorType {
  JWT_EXPIRED = 'JWT_EXPIRED',
  JWT_NOT_ACEPTED = 'JWT_NOT_ACEPTED',
  UNAUTHORIZED = 'UNAUTHORIZED',
}
